import { ShieldCheck } from 'lucide-react';
import { SimpleCrudPage } from './_SimpleCrudPage';
import { epis, type Epi } from '../hooks/useArbreapains';

export function EpisPage() {
  return (
    <SimpleCrudPage<Epi>
      title="EPI (équipements)"
      itemLabel="EPI"
      icon={<ShieldCheck size={18} />}
      query={epis.useList()}
      createMut={epis.useCreate() as never}
      updateMut={epis.useUpdate() as never}
      deleteMut={epis.useDelete()}
      fields={[
        { key: 'name', label: 'Nom', required: true, placeholder: 'Gants nitrile' },
      ]}
    />
  );
}
